var map = {
	"./logo.svg": 11085,
	"./logo2.svg": 13829,
	"./logoL.svg": 21475,
	"./logo_Uptick_lite_s.svg": 24245,
	"./logo_network.svg": 47714,
	"./logo_on_arbitrum.svg": 7520,
	"./logo_on_arbitrum_w.svg": 1706,
	"./logo_on_bsc.svg": 56282,
	"./logo_on_bsc_w.svg": 20172,
	"./logo_on_polygon.svg": 3972,
	"./logo_on_polygon_w.svg": 52926,
	"./logo_upticktestnet.svg": 54481,
	"./logo_w.svg": 6959
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65526;